export default __webpack_public_path__ + "static/media/Ewaluacja_Peter.133c060f.pdf";